/**
 * Returns true when an error originates from an explicit abort
 * (AbortController / AbortSignal) rather than from a real network or server
 * failure.
 */
export const isAbortedFetch = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }

  const cause = (error as Error & { cause?: unknown }).cause;

  // Explicit AbortController abort (e.g. component unmount cleanup)
  if (error.name === 'AbortError') {
    return true;
  }

  if (cause instanceof Error && cause.name === 'AbortError') {
    return true;
  }

  return false;
};
